import _ from 'underscore';

import { Filter } from '~commonInfra/utils/Filter';
import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';
import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { IdentityPoolService } from '~src/authentication/services/IdentityPoolService';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { ListResultWithToken } from '~src/httpClient/fetchers/ListResultWithToken';
import { WebClientListWithTokenResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListWithTokenResourceFetcher';
import { ResourceQueryWithPagingToken } from '~src/httpClient/resources/ResourceQueryWithPagingToken';
import { NamedItemKeys } from '~src/spacesPlatform/models/resourceParts';
import { IServerUserInfo } from '~src/userManagement/users/models/IServerUserInfo';
import { GetServerUsersWithTokenRequest } from '~src/userManagement/users/serverApi/requests/GetServerUsersWithTokenRequest';


function fetchList(params: any): Promise<ListResultWithToken<IServerUserInfo>> {
    const listFetcher = new WebClientListWithTokenResourceFetcher(GetServerUsersWithTokenRequest, ServerApiMapper.serverUsersWithToken);
    const promises: Promise<any>[] = [];

    promises.push(listFetcher.fetchList(params));

    if (FeatureFlags.identityPoolsEnabled) {
        promises.push(IdentityPoolService.tryFetchActiveIdentityPools());
    }

    return Promise.all(promises)
    .then((results: any[]) => {
      const userList: ListResultWithToken<IServerUserInfo> = results.shift();
      if (FeatureFlags.identityPoolsEnabled) {
        const pools: IIdentityPool[] = results.shift();
        _.each(userList.items, (serverUser: IServerUserInfo) => {
          serverUser.poolMemberships = [];

          _.each(serverUser.systemUserIdentities, (record: string[]) => {
            const poolId = record[0];
            const identityId = record[1];
            const identityPool = poolId ? pools.find(x => x.id === poolId) : IdentityPoolService.defaultIdentityPool();
            if (identityPool) {
              serverUser.poolMemberships.push({
                identityPool: identityPool,
                identityUuid: identityId
              });
            }
          });
        });
      }

      return userList;
    });
}

export const FetcherForServerUsersWithToken = {fetchList};

class ServerUsersWithToken extends ResourceQueryWithPagingToken<IServerUserInfo> {
    public static readonly instance = new ServerUsersWithToken(FetcherForServerUsersWithToken);

      // returns the server user with the specified username & domainName.
    public getUserByUsernameAndDomain(username: string, domainName: string): Promise<IServerUserInfo> {
        return this
        .addFilter(Filter.stringFieldEq('username', username))
        .addFilter(Filter.stringFieldEq('domainName', domainName))
        .getFirst();
    }

    // returns the server users with the specified IDs
    public getByUserIds(userIds: string[]): Promise<ListResultWithToken<IServerUserInfo>> {
        const usersFilter = Filter.stringFieldInArray(NamedItemKeys.id, userIds);
        const queryWithFilter = this.addFilter(usersFilter);

        return queryWithFilter.getCount().then((totalCount: number) => {
            return queryWithFilter.getPage(null, totalCount);
        });
    }
}

export const ServerUsersWithTokenResource = ServerUsersWithToken.instance;